/* カナメイ作成のscript類 */
    jQuery(function($){

/*---------------------------------------------------------------------------*/
/* Font Size
/*---------------------------------------------------------------------------*/
        ;(function(){
// 初期表示はSSIで処理しています

        var $target = $("#main-container");
        var $chgFont = $(".change-fontsize");
        var fontSizeStr = $.cookie('font_size') || "large";

        $chgFont
            .find(".std").on("click",function(){
                changeFontSize(1,$(this),"std");
            }).end()
            .find(".large").on("click",function(){
                changeFontSize(1.1,$(this),"large");
            }).end()
            .find(".most-large").on("click",function(){
                changeFontSize(1.2,$(this),"most-large");
            });
        if(fontSizeStr === "std" ){
            $chgFont.find(".std").addClass("active");
        }else {
//cookieからセットする
            $chgFont.find("."+fontSizeStr).trigger("click")
        }

        function changeFontSize(size,el,sizeStr){
            $target.css({"font-size": size + "em"});
            $chgFont.find("span").removeClass("active");
            el.addClass("active");

            $.cookie('font_size', sizeStr, { expires: 30, path: '/' });
        }
    }());

/*--------------------------------------------------------------------------*/
/* menu
/*--------------------------------------------------------------------------*/

    ;(function(){
        var $toggle = $('<span class="menu-toggle"></span>')
        $("#menu").children("ul").children("li").children("a").after($toggle);
    }());

/*--------------------------------------------------------------------------*/
/* FlexSlider
/*--------------------------------------------------------------------------*/

    ;(function(){
        var $mainSlide = $('#main-slide');
        if(!$mainSlide.size()) return;

        var  button_num = 4;

        $mainSlide.flexslider({
            //useCSS: false,
            animation: "fade",              //Select your animation type (fade/slide)
            slideshow: true,                //Should the slider animate automatically by default? (true/false)
            slideshowSpeed: 5000,           //Set the speed of the slideshow cycling, in milliseconds
            animationDuration: 500,         //Set the speed of animations, in milliseconds
            directionNav: true,             //Create navigation for previous/next navigation? (true/false)
            controlNav: true,               //Create navigation for paging control of each clide? (true/false)
            keyboardNav: true,              //Allow for keyboard navigation using left/right keys (true/false)
            touchSwipe: true,               //Touch swipe gestures for left/right slide navigation (true/false)
            prevText: "Previous",           //Set the text for the "previous" directionNav item
            nextText: "Next",               //Set the text for the "next" directionNav item
            randomize: false,                //Randomize slide order on page load? (true/false)
            slideToStart: 0,                //The slide that the slider should start on. Array notation (0 = first slide)
            pauseOnAction: true,            //Pause the slideshow when interacting with control elements, highly recommended. (true/false)
            pauseOnHover: true,            //Pause the slideshow when hovering over slider, then resume when no longer hovering (true/false)
            controlsContainer: ".flex-container",           //Advanced property: Can declare which container the navigation elements should be appended too. Default container is the flexSlider element. Example use would be ".flexslider-container", "#container", etc. If the given element is not found, the default action will be taken.
            manualControls: ".flex-control-nav li",             //Selector: Declare custom control navigation. Example would be ".flex-control-nav li" or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
            start: function(slider){
                var $ctrl_nav_ul = $(".flex-control-nav ul",slider).eq(0)
                , $li = $("li",$ctrl_nav_ul)
                , li_num = $li.size()
//              , li_width = $li.css("width")
                , $ctrl_dir = $(".flex-control-nav-direction",$mainSlide)
                , navIndex = 0
                ;

                if(!( li_num > button_num )){
                    return;
                }else{
                    $ctrl_dir.show();
                }

                if(li_num > button_num){
                    $li.css({width:((100/li_num)-0.5)+"%"});
                    $ctrl_nav_ul.css({width:((100/button_num)*li_num)+"%"});
                }

                $ctrl_dir
                    .find(".next").on("click",function(e){
                        e.preventDefault();
                        if(navIndex < slider.count-1 && navIndex < (slider.count - button_num) ){
                            navIndex++;
                            moveCtrl();
                        }else{
                            navIndex = slider.count - button_num;
                        }
                        checkDirectionDisp(slider);
                    })
                    .end()
                    .find(".prev").on("click",function(e){
                        e.preventDefault();
                        if(navIndex > 0){
                            navIndex--;
                            moveCtrl();
                        }else{
                            navIndex = 0;
                        }
                        checkDirectionDisp(slider);
                    });

                function moveCtrl(){
                    $ctrl_nav_ul.animate({marginLeft:-navIndex*25+"%"},{duration:300,easing:"linear"});
                }

                function checkDirectionDisp(slider){
                    if(navIndex == 0) {
                        $ctrl_dir.find(".prev").hide();
                    }else{
                        $ctrl_dir.find(".prev").show();
                    }

                    if(navIndex == li_num-button_num) {
                        $ctrl_dir.find(".next").hide();
                    }else{
                        $ctrl_dir.find(".next").show();
                    }
                }

                this.before =  function(slider){
                    var $ctrl_nav = $(".flex-control-nav",slider)
//                  , $li = $("li",$ctrl_nav).eq(slider.currentSlide)
                    ;

                    if(slider.animatingTo==0) {
                        $("ul",$ctrl_nav).eq(0).stop().animate({marginLeft:0},{duration:500,easing:"swing"});
                        navIndex =0;
                    }

                    if( (slider.animatingTo > button_num - 1 ) )    {
                        $("ul",$ctrl_nav).eq(0).stop().animate({marginLeft:((button_num-1-slider.animatingTo)*25)+"%"},{duration:500,easing:"swing"});
                    }

// index
                    if( ( slider.animatingTo - button_num) >= 0 ){
                        navIndex = slider.animatingTo - button_num +1;
                    }

                    checkDirectionDisp(slider);
                };

                this.after =  function(slider){
                };

//Callback: function(slider) - Fires when the slider loads the first slide
                checkDirectionDisp(slider);
            },

//Callback: function(slider) - Fires asynchronously with each slider animation
            before: function(slider){
            },

//Callback: function(slider) - Fires after each slider animation completes
            after: function(slider){
            },

//Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
            end: function(slider){
            }
        });

// direction nav mouseover
        $(".flex-container").hover(
            function(){
                $(".flex-direction-nav",this).show();
            },
            function(){
                $(".flex-direction-nav",this).hide();
            }
        );

// movie
        $("#movie-slide").flexslider({
            animation: "fade",              //Select your animation type (fade/slide)
            slideshow: true,                //Should the slider animate automatically by default? (true/false)
            slideshowSpeed: 10000,           //Set the speed of the slideshow cycling, in milliseconds
            animationDuration: 400,         //Set the speed of animations, in milliseconds
            directionNav: false,             //Create navigation for previous/next navigation? (true/false)
            controlNav: true,               //Create navigation for paging control of each clide? (true/false)
            keyboardNav: true,              //Allow for keyboard navigation using left/right keys (true/false)
            touchSwipe: true,               //Touch swipe gestures for left/right slide navigation (true/false)
            prevText: "Previous",           //Set the text for the "previous" directionNav item
            nextText: "Next",               //Set the text for the "next" directionNav item
            randomize: false,                //Randomize slide order on page load? (true/false)
            slideToStart: 0,                //The slide that the slider should start on. Array notation (0 = first slide)
            pauseOnAction: true,            //Pause the slideshow when interacting with control elements, highly recommended. (true/false)
            pauseOnHover: true,            //Pause the slideshow when hovering over slider, then resume when no longer hovering (true/false)
            controlsContainer: ".flex-container",           //Advanced property: Can declare which container the navigation elements should be appended too. Default container is the flexSlider element. Example use would be ".flexslider-container", "#container", etc. If the given element is not found, the default action will be taken.
            manualControls: ".flex-control-nav li",             //Selector: Declare custom control navigation. Example would be ".flex-control-nav li" or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.

//Callback: function(slider) - Fires when the slider loads the first slide
            start: function(slider){
//              this.after(slider);
            },

//Callback: function(slider) - Fires asynchronously with each slider animation
            before: function(slider){
            },

//Callback: function(slider) - Fires after each slider animation completes
            after: function(slider){
            },

//Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
            end: function(){}
        });

    }());

/*--------------------------------------------------------------------------*/
/* Jump to the Top
/*--------------------------------------------------------------------------*/

    ;(function(){
        var topLink = jQuery('#back-to-top');

        function jumpToTop(topLink) {
            if(jQuery(window).scrollTop() > 0) {topLink.show();}
            else {topLink.fadeOut(150);}
        }
        setTimeout(function(){jumpToTop(topLink);},50);
        jQuery(window).scroll( function() {jumpToTop(topLink);});

        topLink.find('a').click( function(e) {
            e.preventDefault();
            jQuery('html, body').stop().animate({scrollTop:0}, 450);
        });
    }());

/*--------------------------------------------------------------------------*/
/* Anchor tag Scrolling
/*--------------------------------------------------------------------------*/

/*
    $("a[href^=#][href!=#]","#main-container").scrollAnchors();
*/


/*--------------------------------------------------------------------------*/
/* Print button
/*--------------------------------------------------------------------------*/

    $("#print-page-preview-btn").on("click",function(e){
        e.preventDefault();
        $("#print-css").attr("media","screen,print");
        $("#print-preview").show();
        $("#print-page-preview-btn").hide();
    });

    $("#print-back-btn").on("click",function(e){
        e.preventDefault();
        $("#print-css").attr("media","print");
        $("#print-preview").hide();
        $("#print-page-preview-btn").show();
    });

    $("#print-this-page-btn").on("click",function(e){
        e.preventDefault();
        print();
    });

}); //jQuery closure end

/*--------------------------------------------------------------------------*/
/* Retina
/*--------------------------------------------------------------------------*/
    var isRetina = function(){
        var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)";
        if (window.devicePixelRatio > 1) {return true;}
        if (window.matchMedia && window.matchMedia(mediaQuery).matches) {return true;}
        return false;
    };



// WEBPACK FOOTER //
// ./src/kanamei.js